export const userConstants = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  COOKIE_LOGIN_REQUEST: "COOKIE_LOGIN_REQUEST",
  COOKIE_LOGIN_SUCCESS: "COOKIE_LOGIN_SUCCESS",
  COOKIE_LOGIN_FAILURE: "COOKIE_LOGIN_FAILURE",

  TOKEN_REFRESH: "TOKEN_REFRESH",

  LOGOUT: "LOGOUT",

  USER_GETLIST_REQUEST: "USER_GETLIST_REQUEST",
  USER_GETLIST_SUCCESS: "USER_GETLIST_SUCCESS",
  USER_GETLIST_FAILURE: "USER_GETLIST_FAILURE",

  USER_GET_DETAIL_REQUEST: "USER_GET_DETAIL_REQUEST",
  USER_GET_DETAIL_SUCCESS: "USER_GET_DETAIL_SUCCESS",
  USER_GET_DETAIL_FAILURE: "USER_GET_DETAIL_FAILURE",

  USER_GET_ALL_ROLES_REQUEST: "USER_GET_ALL_ROLES_REQUEST",
  USER_GET_ALL_ROLES_SUCCESS: "USER_GET_ALL_ROLES_SUCCESS",
  USER_GET_ALL_ROLES_FAILURE: "USER_GET_ALL_ROLES_FAILURE",

  USER_CREATE_REQUEST: "USER_CREATE_REQUEST",
  USER_CREATE_SUCCESS: "USER_CREATE_SUCCESS",
  USER_CREATE_FAILURE: "USER_CREATE_FAILURE",

  USER_EDIT_REQUEST: "USER_EDIT_REQUEST",
  USER_EDIT_SUCCESS: "USER_EDIT_SUCCESS",
  USER_EDIT_FAILURE: "USER_EDIT_FAILURE",

  USER_PWD_RESET_REQUEST: "USER_PWD_RESET_REQUEST",
  USER_PWD_RESET_SUCCESS: "USER_PWD_RESET_SUCCESS",
  USER_PWD_RESET_FAILURE: "USER_PWD_RESET_FAILURE",

  USER_PWD_EDIT_REQUEST: "USER_PWD_EDIT_REQUEST",
  USER_PWD_EDIT_SUCCESS: "USER_PWD_EDIT_SUCCESS",
  USER_PWD_EDIT_FAILURE: "USER_PWD_EDIT_FAILURE",
};
